import { up } from 'up-fetch'

import {
  type IPredictionsLocation,
  type IResponseGetLatLng,
  type IResponseGetRoute,
  type IResponseLocation,
} from '../../types'

const upFetch = up(fetch)

export const searchLocation = async (searchValue: string): Promise<IPredictionsLocation[]> =>
  Promise.all(
    ['country', 'postal_code', 'locality', 'address', 'establishment'].map(async type =>
      searchLocationInType(searchValue, type),
    ),
  ).then(
    values =>
      values
        .map(data => data?.predictions)
        .filter(data => data)
        .flat(1) as IPredictionsLocation[],
  )

export const searchLocationInType = async (searchValue: string, type: string) => {
  try {
    return await upFetch<IResponseLocation>(
      `https://geolocation.cargoking.co.uk/google/place/autocomplete`,
      {
        params: {
          input: searchValue,
          types: type,
        },
      },
    )
  } catch (error) {
    console.error(error)

    return {
      predictions: [],
    }
  }
}

export const getLatLng = async (placeId: string) => {
  const res = await upFetch<IResponseGetLatLng>(
    `https://geolocation.cargoking.co.uk/google/place/details?place_id=${placeId}`,
  )

  return {
    address_components: res?.result?.address_components,
    location: res.result.geometry.location,
  }
}

export const getRoute = async (routes: string[]): Promise<IResponseGetRoute | void> => {
  return upFetch<IResponseGetRoute>(`https://geolocation.cargoking.co.uk/google/directions`, {
    body: {
      routes,
    },
    method: 'POST',
  })
}
